import PropTypes from 'prop-types'
import React from 'react'
import useProductPricing from '../../hooks/use-product-pricing'
import useMultiSite from '../../hooks/use-multi-site'
import DisplayPrice from '../display-price'

const ProductDisplayPrice = ({
    as: Component = DisplayPrice,
    product,
    isBonusProduct,
    variant,
    loading
}) => {
    const {site} = useMultiSite()

    const {price, displayPrice, hasDiscount, isFree} =
        useProductPricing(product, isBonusProduct) || {}

    // content only sites do not render prices
    if (site?.isContentOnlySite) {
        return null
    }

    return (
        <Component
            price={price}
            displayPrice={displayPrice}
            hasDiscount={hasDiscount}
            isFree={isFree}
            loading={loading}
            variant={variant}
            currency={product?.currency}
        />
    )
}

ProductDisplayPrice.propTypes = {
    as: PropTypes.elementType,
    product: PropTypes.object,
    isBonusProduct: PropTypes.bool,
    loading: PropTypes.bool,
    variant: PropTypes.string
}

export default ProductDisplayPrice
